import React from 'react'

export default function usePrintableSectionsConfig({
  emrSections,
  prescriptionViewSettings,
  prescriptionTemplateData,
}) {
  let styleOverrides = prescriptionViewSettings?.styleOverridesForPrintedEmrSections
  const templateOverrides = prescriptionTemplateData?.body?.styleOverridesForPrintedEmrSections


  emrSections?.forEach((section) => {
    const sectionId = section.id
    if (templateOverrides && templateOverrides[sectionId]) {
      styleOverrides = {
        ...styleOverrides,
        [sectionId]: {
          ...styleOverrides?.[sectionId],
          ...templateOverrides[sectionId],
        },
      }
    }
  })

  return {
    styleOverrides,
  }
}
